import { render, staticRenderFns } from "./ThisOrThat.vue?vue&type=template&id=4d87a708&"
import script from "./ThisOrThat.vue?vue&type=script&lang=js&"
export * from "./ThisOrThat.vue?vue&type=script&lang=js&"
import style0 from "./ThisOrThat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ThisOrThat.vue"
export default component.exports